import React, { Component } from 'react'
import './App.css'
import 'babel-polyfill'
import $ from 'jquery'
import Scroll from 'react-scroll'
import CanvasMap from './canvas-map'
import Header from './Header'
import Nav from './Nav'
import Intro from './Intro'
import Article from './Article'
import Footer from './Footer'
import mapSrc from './images/map2.svg'
import SocialBar from './SocialBar'
import Logo from './Logo'
import plane from './images/plane2.svg'


let Events = Scroll.Events

let App = React.createClass({


	componentDidMount () {
	    let map=CanvasMap({
		  textContainer:document.querySelector('.text'),
		  mapSrc:{mapSrc}.mapSrc,
		  trailVisitedColor:'#61c1d2',
		  fontPresentColor:'#5D5C56',
		}).appendTo('.container')


		var c = document.createElement('canvas');
		var cx = c.getContext('2d');
		var images = document.querySelectorAll('.rollover');
		var all = images.length;
		var ox = 0;
		var oy = 0;

		while (all--) {
			images[all].addEventListener('mouseover', copyimage, false);
			images[all].addEventListener('mousemove', hover, false);
			images[all].addEventListener('mouseout', resetimg, false);
		}

		function copyimage(ev) {
			var img = ev.target;
			c.width = img.offsetWidth;
			c.height = img.offsetHeight;
			cx.drawImage(img, 0, 0, img.offsetWidth, img.offsetHeight);
			ox = img.offsetLeft;
			oy = img.offsetTop;
		}

		function resetimg(ev) {
			ev.target.classList.remove('over');
		}

		function hover(ev) {
			var x = ev.clientX - ox;
			var y = ev.clientY - oy;
			var pixelcolour = cx.getImageData(x, y, 1, 1);
			if (pixelcolour.data[3] === 0) {
			  ev.target.classList.remove('over');
			  $("#infographic_data").addClass("hidden")
			} else {
			  ev.target.classList.add('over');
			  $("#infographic_data").removeClass("hidden")
			}
		}

		let infographic_desk = $('#infographic_desk')
		let infographic_mobile = $('#infographic_mobile')
		let articles = $('.ship')
		let nav = $('#small-nav')
		let video = $('#covervid')
		let hotmenu = $('.hot_menu')
		let submenu = $('.submenu')

		function mediaqueryresponse(mql){
		 if (mql.matches){ // if media query matches
		    infographic_desk.removeClass("hidden")
		    infographic_mobile.addClass("hidden")
		    nav.removeClass("hidden")
		    articles.attr("data-icon", {plane}.plane)
		    video.attr("autoplay", true)
		    hotmenu.mouseover(function() {
				submenu.css("display", "block")
			});

			submenu.mouseover(function() {
				submenu.css("display", "block")
			});

			hotmenu.mouseout(function() {
				submenu.css("display", "none")
			});

			submenu.mouseout(function() {
				submenu.css("display", "none")
			});
		 }
		 else{
		    infographic_desk.addClass("hidden")
		    infographic_mobile.removeClass("hidden")
		    nav.addClass("hidden")
		    articles.removeAttr("data-icon")
		    video.attr("autoplay", false)
		    
		    hotmenu.on('click', function() {
		    	let state = (submenu.css('display') === 'none')
			    submenu.css("display", state ? "block" : 'none');
			    state = !state;
			});
		 }
		}

		var mql = window.matchMedia('(min-width: 720px)')
		mediaqueryresponse(mql) // call listener function explicitly at run time
		mql.addListener(mediaqueryresponse) // attach listener function to listen in on state changes
	  },

  render() {
  	/* menu auto show and smooth scroll*/
	$(function() {
	    function getScrollHeight() {
	        return window.pageYOffset || document.documentElement.scrollTop
	    }
	    var windowHeight = $(window).height();
	    $(window).scroll(function() {
	    	$('.submenu').css("display", "none")
	    	var infoDistance = $(".infographic").offset().top - $(".text").offset().top;
	        var scrollHeight = getScrollHeight();
	        if (infoDistance >= windowHeight*(-0.5)) {
	        	$(".infographic").addClass("hidden")
	        	$("nav").removeClass("hidden")
	        	$(".text").removeClass("clear")
	        } else {
	        	$(".infographic").removeClass("hidden")
	        	$("nav").addClass("hidden")
	        	$(".text").addClass("clear")
	        }
	        if (infoDistance >= windowHeight*(-0.3)) {
	        	$(".container").removeClass("hidden")
	        } else {
	        	$(".container").addClass("hidden")
	        }
	    })

	    // $('a[href^="#"]').on('click', function(event) {
	    //     var target = $(this.getAttribute('href'));
	    //     if( target.length ) {
	    //         event.preventDefault();
	    //         $('html, body').stop().animate({
	    //             scrollTop: target.offset().top
	    //         }, 1000);
	    //     }
	    // });
	})

    return (
      <div className="main">
        <Header />
        <SocialBar />
        <Logo />
        <Intro />
        <Nav />
        <Article />
        <Footer />
      </div>
    )
  }
})

export default App;



/** WEBPACK FOOTER **
 ** ./src/App.js
 **/